export class Quote
{
	quoteId: number;
	checkInDate: any;
	checkOutDate: any;
  guestMasterProfileId: any;
  createDate: any;
  lastUpdate: any;
  reservationistUserId: number;
  sendEmail: boolean;
  checkInDateTime: any;
  checkOutDateTime: any;
  numAdults: number;
  numChildren: number;
  quoteExpirationDateTime: any;
}
